module.exports = __webpack_public_path__ + "img/banner.4822302f.png";